
import { Style } from '@/libs/style.js';

let template = /*html*/ `<div class="xbt-app-technology">
    <img src="./images/xbt/2.png" class="technology-img"/>
    <div class="technology-warn-content">
        <div class="warn-box" v-for="(item,index) in warnPos" :key="index" :style="{top:item[0]+'px',left:item[1]+'px'}" @click="openTechnologyDevice">
        </div>
    </div>
 </div>`;


let style = /* css */ `
 .xbt-app-technology{
    position: absolute;
        top: calc(10% + 250px);
        width: 45%;
        height:60%;
        left:50%;
        transform: translateX(-50%);
        // background: rgba(0,0,0,0.7);
        display:flex;
        overflow:hidden;
 }
 .xbt-app-technology .technology-img{
    width: auto;
    display: block;
    width:100%;
    margin:auto;
 }
 .xbt-app-technology .technology-warn-content{
    position:absolute;
    inset:0;
 }
 .xbt-app-technology .warn-box{
    position:absolute;
    cursor: pointer;
    width: 50px;
          height: 50px;
          border-radius: 100%;
          background: #f38f4a;
          transform: translate(0, 50%) scale(0.5);
          animation: flashLight 1s linear infinite;

          opacity: 0.8;
 }
@keyframes flashLight {
    from {
      transform: translate(0, 50%) scale(0.5);
      opacity: 0.8;
    }
    to {
      transform: translate(0, 50%) scale(1.5);
      opacity: 0;
    }
  }
 `;

export default (Vue) => {
    Vue.customElement('xbt-app-technology', {
        template: template,
        data() {
            return {
                warnPos: [[66, 455], [281, 251], [366, 389]],
                config: {
                    data: [
                    ],
                    align: ['center'],

                }
            }
        },
        mounted() {
            Style(style);
        },
        methods: {
            openTechnologyDevice() {
                this.$Application.run('xbt-device-view', { newWindow: true })
            }
        }
    });
}